<template>
    <div
        class="date-display"
        :style="{ '--text-size': textSize }"
        v-if="lastUpdateDate"
    >
        <Icon
            is-local
            width="15"
            height="15"
            :fill="textColor"
            icon-source="calendar"
        />
        <span class="text" :style="{ color: textColor }">
            {{ $t('Last Updated') }} {{ lastUpdateDate }}
        </span>
    </div>
</template>

<script>
import { DateMixin } from '@/ghost-mixins';

export default {
    name: 'DateDisplay',
    mixins: [DateMixin],
    props: {
        textColor: {
            type: String,
        },
        textSize: {
            type: String,
        },
    },
    data() {
        return {
            lastUpdateDate: this.getBrowserData() ?? this.fallbackDate(),
        };
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.date-display {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    color: white;
    max-width: 1200px;
    margin: 0 auto;
    align-items: center;
    padding: 10px 20px;
    @include mq('tablet') {
        padding: 10px 40px;
    }

    .base-icon {
        margin-right: 5px;
    }

    span {
        padding-right: 5px;
    }

    .text {
        font-size: var(--text-size);
        font-weight: bold;
        line-height: 15px;

        color: white;
    }
}
</style>
